import { Injectable } from "@angular/core";
import { LoggerService } from "@bfx/logger";
import { OENCommand } from "app/order-entry/data/enums/oe-command.enum";
import { OECommandEventModel } from "app/order-entry/data/models/oe-command-event.model";
import { Subject } from "rxjs";
const logger = LoggerService.for(__dirname);

/**
 * Defines channels that can be used to directly send messages to parts of the OE subsystem without
 * having to to have a reference to that subsystem. This allows for decoupling and for lower-level services to trigger top-level
 * commands.
 * Currently, access to command generation is limited to explicit methods.
 */
@Injectable()
export class OEAPIChannelService {
  private oeApiMessageSource = new Subject<OECommandEventModel>();

  /** Observable used by oe-api-service */
  public oeApiMessage$ = this.oeApiMessageSource.asObservable();

  constructor() {
    this.initialize();
  }

  private initialize(): void {}

  /**
   * Refresh the strategy for the specified refId. This is normally only needed to be called by
   * threads processing rollback events for a monitored order. Needed specifically when rolling back a modification that may
   * have added or changed multiple strategy legs
   *
   * @param refId
   * @param orderId
   */
  public refreshOrderStrategy(refId: string, orderId: string) {
    logger.out.info(`oac-s - sending refreshOrderStrategy to API for order ${orderId}`);
    const command = new OECommandEventModel(refId, OENCommand.REFRESH_STRATEGY, { refId, orderId });
    this.oeApiMessageSource.next(command);
  }
}
